import {
  MicrosoftConnectFailure,
  MicrosoftConnectRefusal,
} from '@this+that/models';

import { resolveRestErrorKey } from './restErrors';

// CONNECT_FAILED has no entry on purpose: it is the generic failure the fallback copy already says.
const CONNECT_ERROR_MESSAGE_KEYS: ReadonlyMap<string, string> = new Map<
  string,
  string
>([
  [
    MicrosoftConnectRefusal.ACCOUNT_HELD_BY_ANOTHER_USER,
    'integration.microsoftAccountHeldByAnotherUser',
  ],
  [
    MicrosoftConnectFailure.PERMISSIONS_NOT_GRANTED,
    'integration.microsoftPermissionsNotGranted',
  ],
  [
    MicrosoftConnectFailure.TEAMS_PERSONAL_ACCOUNT,
    'integration.teamsPersonalAccountNotSupported',
  ],
]);

// Each Outlook and Teams connect renders one generic failure toast; a coded refusal or failure gets its own copy.
export const resolveMicrosoftConnectErrorKey = (
  error: unknown,
  fallbackKey: string,
): string =>
  resolveRestErrorKey(error, CONNECT_ERROR_MESSAGE_KEYS, fallbackKey);
